import { Route, Routes } from "react-router";
import AsyncReports from "./AsyncReports";
import ScheduledReports from "./ScheduledReports";

function ReportsRoutes() {
  return (
    <Routes>
      <Route path="" element={<AsyncReports />} />
      <Route path="scheduled" element={<ScheduledReports />} />
    </Routes>
  );
}

export default ReportsRoutes;
